import type { PickEventDetail, Web3DViewer } from '@technology/web3d';
import { getLogger } from '@trimble/logging';
import {
  ISSUE_MARKERS_MODEL_ID,
  isIssueMarkerUserData,
} from './issue-marker-sprite.types';
import { IssueMarkersPlugin } from './issue-markers-plugin';

export function getIssueMarkersPlugin(
  viewer: Web3DViewer
): IssueMarkersPlugin | undefined {
  const existing = viewer.plugins.get(IssueMarkersPlugin);
  if (existing) {
    return existing;
  }

  try {
    const plugin = new IssueMarkersPlugin();
    viewer.addPlugin(plugin);
    return plugin;
  } catch (error: unknown) {
    getLogger().warn('Failed to register IssueMarkersPlugin', { error });
    return undefined;
  }
}

export function resolveIssueMarkerHashIdFromPick(
  viewer: Web3DViewer,
  detail: PickEventDetail
): number | undefined {
  if (detail.modelId !== ISSUE_MARKERS_MODEL_ID || detail.id === undefined) {
    return undefined;
  }

  const model = viewer.plugins.get(IssueMarkersPlugin)?.getModel();
  const userData: unknown = model?.root.getObjectById(detail.id)?.userData;
  return isIssueMarkerUserData(userData) ? userData.markerHashId : undefined;
}
